module.exports = __webpack_public_path__ + "static/media/highheel.2556903b.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/highheel.png
// module id = 37
// module chunks = 0